document.addEventListener('DOMContentLoaded', () => {
  // Esperar que el carrito lateral cargue
  setTimeout(() => {
    const drawerFooter = document.querySelector('.cart-drawer__footer.pl2.pr2');
    if (!drawerFooter) return; // si no existe, no hace nada

    // Buscar el botón de checkout dentro del drawer
    const checkoutBtn = drawerFooter.querySelector('button[name="checkout"], .cart-drawer__checkout');
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = '0.5';
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.textContent = 'Selecciona comuna y fecha antes de pagar';
    }

    // Buscar o crear botón para ir al carrito completo
    let viewCartBtn = drawerFooter.querySelector('a[href="/cart"]');
    if (!viewCartBtn) {
      viewCartBtn = document.createElement('a');
      viewCartBtn.href = '/cart';
      drawerFooter.appendChild(viewCartBtn);
    }
    viewCartBtn.textContent = 'Ir al carrito para seleccionar comuna y fecha';
    viewCartBtn.style.display = 'inline-block';
    viewCartBtn.style.backgroundColor = '#000';
    viewCartBtn.style.color = '#fff';
    viewCartBtn.style.padding = '10px 15px';
    viewCartBtn.style.borderRadius = '4px';

  }, 1500); // 1.5s espera para que Peak cargue el drawer
});
